
import { defineComponent, reactive, toRefs } from "vue";
import { TUIEnv } from "./TUIKit/TUIPlugin";
import { handleErrorPrompts } from "./TUIKit/TUIComponents/container/utils";
import { TUIComponents, TUICore, genTestUserSig } from "./TUIKit";
import { TUICallKit } from "@tencentcloud/call-uikit-vue";
import { JSONToObject } from "./TUIKit/TUIComponents/container/TUIChat/utils/utils";
export default defineComponent({
  name: "App",

  setup() {
    const data = reactive({
      env: TUIEnv(),
      currentModel: "conversation",
      showCall: false,
      showCallMini: false,
      showTUIChat: false,
      showMain: true,
    });
    const closeTxChat = () => {
      const closeTxChatMessage = new BroadcastChannel("closeTxChatMessage");
      closeTxChatMessage.postMessage({});
    };
    const channel = new BroadcastChannel("sendHouseMessage");
    channel.addEventListener("message", (event) => {
      data.showTUIChat = true;
      let messageData = JSONToObject(event.data);
      let cookieKey = messageData.fromUserId + "" + messageData.toUserId;
      let houseId = getCookie(cookieKey);
      if (houseId != messageData.houseData.data.houseid) {
        setCookie(cookieKey, messageData.houseData.data.houseid, 60 * 30);
        sendHouseMessage(messageData);
      } else {
        const name = `C2C${messageData.toUserId || 3}`;
        TUIServer.TUIConversation.getConversationProfile(name).then(
          (imResponse: any) => {
            // 通知 TUIConversation 模块切换当前会话
            // Notify TUIConversation to toggle the current conversation
            TUIServer.TUIConversation.handleCurrentConversation(
              imResponse.data.conversation
            );
          }
        );
      }
    });
    function setCookie(
      key: string,
      value: string,
      expiresInSeconds: number
    ): void {
      const currentDate = new Date();
      currentDate.setTime(currentDate.getTime() + expiresInSeconds * 1000);
      const expires = currentDate.toUTCString();
      let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(
        value
      )}`;
      cookieString += `; expires=${expires}`;
      document.cookie = cookieString;
    }
    // 获取特定的 cookie 值
    function getCookie(key: string): string {
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookiesArray = decodedCookie.split(";");

      for (let i = 0; i < cookiesArray.length; i++) {
        let cookie = cookiesArray[i];
        while (cookie.charAt(0) === " ") {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(`${key}=`) === 0) {
          return cookie.substring(`${key}=`.length, cookie.length);
        }
      }
      return "";
    }
    const textMessagechannel = new BroadcastChannel("defaultTextCallMessage");
    textMessagechannel.addEventListener("message", (event) => {
      data.showTUIChat = true;
      let messageData = JSONToObject(event.data);
      let cookieKey = messageData.fromUserId + "" + messageData.toUserId;
      let value = getCookie(cookieKey);
      if (value == "") {
        DefaultTextCall(messageData);
        setCookie(cookieKey, "1", 10);
      } else {
        const name = `C2C${messageData.toUserId || 3}`;
        TUIServer.TUIConversation.getConversationProfile(name).then(
          (imResponse: any) => {
            // 通知 TUIConversation 模块切换当前会话
            // Notify TUIConversation to toggle the current conversation
            TUIServer.TUIConversation.handleCurrentConversation(
              imResponse.data.conversation
            );
          }
        );
      }
    });
    const DefaultTextCall = async (messageData: any) => {
      data.showTUIChat = true;
      const name = `C2C${messageData.toUserId || 3}`;
      TUIServer.TUIConversation.getConversationProfile(name).then(
        (imResponse: any) => {
          // 通知 TUIConversation 模块切换当前会话
          // Notify TUIConversation to toggle the current conversation
          TUIServer.TUIConversation.handleCurrentConversation(
            imResponse.data.conversation
          );
          setTimeout(async () => {
            let cloudCustomData, res;
            res = await TUIServer.TUIChat.sendTextMessage(
              JSON.parse(JSON.stringify(messageData.text), cloudCustomData)
            );
          }, 500);
        }
      );
    };

    const TUIServer = (window as any)?.TUIKitTUICore?.TUIServer;
    const handleCurrentConversation = (value: string) => {
      data.currentModel = value ? "message" : "conversation";
    };
    const initChannel = new BroadcastChannel("initUserMessage");
    initChannel.addEventListener("message", (event) => {
      data.showTUIChat = true;
      let messageData = JSONToObject(event.data);
      initUser(messageData);
    });
    const openOrOffChatMessage = new BroadcastChannel("openOrOffChatMessage");
    openOrOffChatMessage.addEventListener("message", (event) => {
      let messageData = JSONToObject(event.data);
      data.showMain = messageData.show;
    });
    const initUser = (messageData: any) => {
      //初始化登录信息
      const SDKAppID = 1400828201; // Your SDKAppID
      const secretKey =
        "28ba91d2e8954c91f8a98b3c8cea1af0b5a9f7ddfe663f951187895dea5a0e7d"; //Your secretKey
      const userID = messageData.fromUserId || 1 + ""; // User ID
      // init TUIKit
      const TUIKit = TUICore.init({
        SDKAppID,
      });
      // TUIKit add TUIComponents
      TUIKit.use(TUIComponents);
      // TUIKit add TUICallKit
      TUIKit.use(TUICallKit);
      // TUIKit.logout();
      // login TUIKit
      TUIKit.login({
        userID: userID,
        userSig: genTestUserSig({
          SDKAppID,
          secretKey,
          userID,
        }).userSig, // The password with which the user logs in to IM. It is the ciphertext generated by encrypting information such as userID.For the detailed generation method, see Generating UserSig
      });
    };
    const sendHouseMessage = (messageData: any) => {
      //发送房源卡片消息消息（自定义信息）
      data.showTUIChat = true;
      const name = `C2C${messageData.toUserId || 3}`;
      TUIServer.TUIConversation.getConversationProfile(name).then(
        (imResponse: any) => {
          // 通知 TUIConversation 模块切换当前会话
          // Notify TUIConversation to toggle the current conversation
          TUIServer.TUIConversation.handleCurrentConversation(
            imResponse.data.conversation
          );
          setTimeout(() => {
            sendHouseCardMessage(messageData.houseData);
          }, 500);
        }
      );
    };
    const sendHouseCardMessage = (houseData: any) => {
      TUIServer.TUIChat.sendHouseMessage(houseData);
    };
    // beforeCalling：在拨打电话前与收到通话邀请前执行
    const beforeCalling = (type: string, error: any) => {
      if (error) {
        handleErrorPrompts(error, type);
        return;
      }
      data.showCall = true;
    };
    // afterCalling：结束通话后执行
    const afterCalling = () => {
      data.showCall = false;
      data.showCallMini = false;
    };
    // onMinimized：组件切换最小化状态时执行
    const onMinimized = (
      oldMinimizedStatus: boolean,
      newMinimizedStatus: boolean
    ) => {
      data.showCall = !newMinimizedStatus;
      data.showCallMini = newMinimizedStatus;
    };
    // onMessageSentByMe：在整个通话过程内发送消息时执行
    const onMessageSentByMe = async (message: any) => {
      TUIServer?.TUIChat?.handleMessageSentByMeToView(message);
      return;
    };
    return {
      ...toRefs(data),
      handleCurrentConversation,
      beforeCalling,
      afterCalling,
      onMinimized,
      onMessageSentByMe,
      sendHouseMessage,
      sendHouseCardMessage,
      initUser,
      closeTxChat,
      DefaultTextCall,
    };
  },
});
